var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.16675H16.25C14.8134 2.16675 13.4357 2.73743 12.4198 3.75325C11.404 4.76908 10.8333 6.14683 10.8333 7.58341V10.8334H7.58334V15.1667H10.8333V23.8334H15.1667V15.1667H18.4167L19.5 10.8334H15.1667V7.58341C15.1667 7.2961 15.2808 7.02055 15.484 6.81738C15.6871 6.61422 15.9627 6.50008 16.25 6.50008H19.5V2.16675Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.316dba476c396a8f6eac419f7fe96f28.svg";
export { ForwardRef as ReactComponent };